export const ZOOM_FOR_10_METERS = 19
export const ZURICH_LAT_LNG: google.maps.LatLngLiteral = {
    lat: 47.376,
    lng: 8.541,
}

export const layoutHeaderHeigth = 60
